(function () {
  const CREDIT_BACK_FLOW_ID = 351917;
  const ELIGIBLE_ATTRIBUTE = '_alia_credit_back_eligible';
  const SIGNUP_ATTRIBUTE = '_alia_credit_back_signup_at';

  document.addEventListener('alia:signup', function (event) {
    const signup = event.detail || {};

    if (Number(signup.popupID) !== CREDIT_BACK_FLOW_ID) return;

    const attributes = {};
    attributes[ELIGIBLE_ATTRIBUTE] = 'true';
    attributes[SIGNUP_ATTRIBUTE] = String(Math.floor(Date.now() / 1000));

    fetch((window.routes && window.routes.cart_update_url) || '/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({ attributes: attributes }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Unable to save credit-back eligibility');
        return response.json();
      })
      .then(function () {
        document.dispatchEvent(new CustomEvent('zorali:credit-back-eligible'));

        if (window.location.pathname.replace(/\/$/, '') === '/cart') {
          window.location.reload();
        }
      })
      .catch(function (error) {
        console.error('[Zorali] Credit-back eligibility was not saved.', error);
      });
  });
})();
